import * as constants from '@/store/constants'
import * as mixinConstants from '@/mixin/constants'

const state = {
  levelNo: 0,
  unitNo: 0,
  lessonIndex: 0,
  pathIndex: 0,
  pathstepIndex: 0,
  lessonJson: null,
  lessonScore: null,
  lessonState: constants.LESSON_STATE_INIT
}

const getters = {
  levelNo(state) {
    return state.levelNo
  },
  unitNo(state) {
    return state.unitNo
  },
  lessonIndex(state) {
    return state.lessonIndex
  },
  pathIndex(state) {
    return state.pathIndex
  },
  pathstepIndex(state) {
    return state.pathstepIndex
  },
  lessonJson(state) {
    return state.lessonJson
  },
  lessonScore(state) {
    return state.lessonScore
  },
  currentUnit(state) {
    return getCurrentUnit(state)
  },
  currentLevel(state) {
    return getCurrentLevel(state)
  },
  currentPath(state) {
    return getCurrentPath(state)
  },
  level: (state, getters) => (params) => {
    return getLevelByLevelNo(state.lessonScore.levels, params.levelNo)
  },
  unit: (state, getters) => (params) => {
    var level = getters.level(params)
    return getUnitByUnitNo(level.units, params.unitNo)
  },
  lesson: (state, getters) => (params) => {
    var unit = getters.unit(params)
    return unit.lessons[params.lessonIndex]
  },
  path: (state, getters) => (params) => {
    var lesson = getters.lesson(params)
    return lesson.paths[params.pathIndex]
  },
  lessonState(state) {
    return state.lessonState
  },
  allProgress(state) {
    var allOk = 0
    var allTotal = 0
    var progress = 0
    var json = JSON.stringify(state.lessonScore)

    for (var level of state.lessonScore.levels) {
      for (var unit of level.units) {
        for (var lesson of unit.lessons) {
          for (var path of lesson.paths) {
            allOk += path.ok
            allTotal += path.total
          }
        }
      }
    }

    if (allOk == 0) {
      progress = 0
    } else {
      progress = Math.floor(allOk / allTotal * 100)
    }

    return progress
  }
}

const actions = {
  /**
   * レッスンスコア情報を初期化する
   *
   * @param {Object} commit - commit
   * @param {Array} levels - コンテンツデータのレベル情報一覧
   */
  initLessonScore({commit}, levels) {
    commit('initLessonScore', levels)
  },
  setLevelNo({commit}, levelNo) {
    commit('setLevelNo', levelNo)
  },
  setUnitNo({commit}, unitNo) {
    commit('setUnitNo', unitNo)
  },
  setLessonIndex({commit}, lessonIndex) {
    commit('setLessonIndex', lessonIndex)
  },
  setPathIndex({commit}, pathIndex) {
    commit('setPathIndex', pathIndex)
  },
  setPathstepIndex({commit}, pathstepIndex) {
    commit('setPathstepIndex', pathstepIndex)
  },
  setLessonJson({commit}, lessonJson) {
    commit('setLessonJson', lessonJson)
  },
  /**
   * 指定されたPathstepの解答を設定して、スコアを計算する
   * key-value取得APIで取得したレッスンスコアを設定する際の使用を想定
   *
   * @param {Object} commit - commit
   * @param {Object} params - Pathstepの解答情報 { levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex, ok, ng, skip }
   */
  setPathstep({commit}, params) {
    commit('setPathstep', params)
  },
  /**
   * 現在のPathstepの解答を設定して、スコアを計算する
   * 問題解答時にレッスンスコアを設定する際の使用を想定
   *
   * @param {Object} commit - commit
   * @param {Object} status - Pathstepの解答情報 status
   */
  setCurrentPathstep({commit}, status) {
    commit('setCurrentPathstep', status)
  },
  /**
   * 現在のPathstepの解答状態を全てSKIPにする
   * 問題開始時に一旦SKIPで初期化する際の使用を想定
   *
   * @param {Object} commit - commit
   */
  setPathstepAllSkip({commit}) {
    commit('setPathstepAllSkip')
  },
  /**
   * 現在のPathの解答状態を全て0にする
   *
   * @param {Object} commit - commit
   */
  setPathAllReset({commit}) {
    commit('setPathAllReset')
  },
  /**
   *
   */
  setLessonState({commit}, status) {
    commit('setLessonState', status)
  },
  /**
   * マイルストーン用のレッスンスコア情報初期化処理
   * 問題開始時、マイルストーンの問題抽出処理完了後に使用する想定

   * params = {milestoneQuestion, levelJson}
   */
   initLessonScoreForMilestone({commit}, params) {
     commit('initLessonScoreForMilestone', params)
   }
}

const mutations = {
  /**
   * レッスンスコア情報を初期化する
   *
   * @param {state} state - state
   * @param {Array} levels - コンテンツデータのレベル情報一覧
   */
  initLessonScore(state, levels) {
    var lessonScore = { levels: []}
    for (var i = 0; i < levels.length; i++) {
      var level = levels[i]
      lessonScore.levels.push({ levelNo: level.levelNo, units: [] })
      initScoreUnit(lessonScore.levels[i].units, level.units)
    }
    state.lessonScore = lessonScore
  },
  setLevelNo(state, levelNo) {
    state.levelNo = levelNo
  },
  setUnitNo(state, unitNo) {
    state.unitNo = unitNo
  },
  setLessonIndex(state, lessonIndex) {
    state.lessonIndex = lessonIndex
  },
  setPathIndex(state, pathIndex) {
    state.pathIndex = pathIndex
  },
  setPathstepIndex(state, pathstepIndex) {
    state.pathstepIndex = pathstepIndex
  },
  setLessonJson(state, lessonJson) {
    state.lessonJson = lessonJson
  },
  /**
   * 指定されたPathstepの解答を設定して、スコアを計算する
   * key-value取得APIで取得したレッスンスコアを設定する際の使用を想定
   *
   * @param {state} state - state
   * @param {Object} params - Pathstepの解答情報 { levelNo, unitNo, lessonIndex, pathIndex, pathstepIndex, ok, ng, skip }
   */
  setPathstep(state, params) {
    // 解答情報取得
    var level = getLevelByLevelNo(state.lessonScore.levels, params.levelNo)
    var unit = getUnitByUnitNo(level.units, params.unitNo)
    var lesson = unit.lessons[params.lessonIndex]
    var path = lesson.paths[params.pathIndex]
    var pathstep = path.pathsteps[params.pathstepIndex]

    // 対象Pathstep解答を設定
    if (params.ok != null) {
      pathstep.ok = params.ok
    }
    if (params.ng != null) {
      pathstep.ng = params.ng
    }
    if (params.skip != null) {
      pathstep.skip = params.skip
    }
    pathstep.count = pathstep.ok + pathstep.ng + pathstep.skip

    // スコア計算
    calcLessonScore(path, pathstep)
  },
  /**
   * 現在のPathstepの解答を設定して、スコアを計算する
   * 問題解答時にレッスンスコアを設定する際の使用を想定
   *
   * @param {state} state - state
   * @param {Object} status - Pathstepの解答情報
   */
  setCurrentPathstep(state, status) {
    // 解答情報取得
    var path = getCurrentPath(state)
    var pathstep = path.pathsteps[state.pathstepIndex]

    // 対象Pathstep解答を設定
    switch (status) {
      case constants.ACT_STATE_OK:
        pathstep.skip--
        pathstep.ok++
        break
      case constants.ACT_STATE_NG:
        pathstep.skip--
        pathstep.ng++
        break
    }

    // スコア計算
    calcLessonScore(path, pathstep)
  },
  /**
   * 現在のPathstepの解答状態を全てSKIPにする
   * 問題開始時に一旦SKIPで初期化する際の使用を想定
   *
   * @param {state} state - state
   */
  setPathstepAllSkip(state) {
    // 解答情報取得
    var path = getCurrentPath(state)
    var pathstep = path.pathsteps[state.pathstepIndex]

    // 対象Pathstep解答を設定
    pathstep.ok = 0
    pathstep.ng = 0
    pathstep.skip = pathstep.total
    pathstep.count = pathstep.total

    // スコア計算
    calcLessonScore(path, pathstep)
  },
  /**
   * 現在のPathの解答状態を全て0にする
   *
   * @param {state} state - state
   */
  setPathAllReset(state) {
    // 解答情報取得
    var path = getCurrentPath(state)

    // 対象Path解答を設定
    for (var pathstep of path.pathsteps) {
      pathstep.ok = 0
      pathstep.ng = 0
      pathstep.skip = 0
      pathstep.count = 0

      // スコア計算
      calcLessonScore(path, pathstep)
    }
  },
  /**
   *
   */
  setLessonState(state, status) {
    state.lessonState = status
  },
  /**
   * マイルストーン用のレッスンスコア情報初期化処理
   * params = {milestoneQuestion, levelJson}
   */
  initLessonScoreForMilestone(state, params) {
    var path = getCurrentPath(state)
    path.total = 0

    // 問題データからtotal値を設定
    for(var i=0; i < params.milestoneQuestion.length; i++) {
      var question = params.milestoneQuestion[i]
      var key = Object.keys(question)
      var keySplit = key[0].split('-')

      // 問題データを取得
      var json = JSON.parse(JSON.stringify(question))
      var split = json[key[0]].split('-')

      var unitJson = getUnitJson(params.levelJson, Number(split[1]))
      var pathstepData = unitJson.lessons[Number(split[2])].paths[Number(split[3])].pathsteps[Number(split[4])]

      // 対象のpathstepを取得
      var pathstep = path.pathsteps[Number(keySplit[4])]

      pathstep.total = pathstepData.acts.filter(function(act) { return act.challenge != 0 }).length
      path.total += pathstep.total

      // スコア計算
      calcLessonScore(path, pathstep)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}

/**
 * 現在のレッスンスコア(レベル)を取得する
 *
 * @param {state} state state
 */
function getCurrentLevel(state) {
  var level = getLevelByLevelNo(state.lessonScore.levels, state.levelNo)
  return level
}
/**
 * 現在のレッスンスコア(ユニット)を取得する
 *
 * @param {state} state state
 */
function getCurrentUnit(state) {
  var level = getCurrentLevel(state)
  var unit = getUnitByUnitNo(level.units, state.unitNo)
  return unit
}
/**
 * 現在のレッスンスコア(Path)を取得する
 *
 * @param {state} state state
 */
function getCurrentPath(state) {
  var unit = getCurrentUnit(state)
  var lesson = unit.lessons[state.lessonIndex]
  var path = lesson.paths[state.pathIndex]
  return path
}
/**
 * 指定されたレベル情報一覧から指定されたレベル番号のレベル情報を取得する
 *
 * @param {Array} levels レベル情報一覧
 * @param {Number} levelNo レベル番号
 * @return {Object} 指定されたレベル番号のレベル情報
 */
function getLevelByLevelNo (levels, levelNo) {
  var result
  for (var level of levels) {
    if (level.levelNo == levelNo) {
      result = level
      break
    }
  }
  return result
}
/**
 * 指定されたユニット情報一覧から指定されたユニット番号のユニット情報を取得する
 *
 * @param {Array} units ユニット情報一覧
 * @param {Number} unitNo ユニット番号
 * @return {Object} 指定されたユニット番号のユニット情報
 */
function getUnitByUnitNo (units, unitNo) {
  var result
  for (var unit of units) {
    if (unit.unitNo == unitNo) {
      result = unit
      break
    }
  }
  return result
}
/**
 * 指定されたコンテンツデータ(ユニット一覧)からレッスンスコア用のユニット一覧を作成する
 *
 * @param {Array} units レッスンスコア用のユニット一覧
 * @param {Array} source コンテンツデータ(ユニット一覧)
 */
function initScoreUnit (units, source) {
  for (var i = 0; i < source.length; i++) {
    var unit = source[i]
    units.push({
      unitNo: unit.unitNo,
      title: unit.title,
      lessons: [],
    })
    initScoreLesson(units[i].lessons, unit.lessons)
  }
}
/**
 * 指定されたコンテンツデータ(レッスン一覧)からレッスンスコア用のレッスン一覧を作成する
 *
 * @param {Array} units レッスンスコア用のレッスン一覧
 * @param {Array} source コンテンツデータ(レッスン一覧)
 */
function initScoreLesson (lessons, source) {
  for (var i = 0; i < source.length; i++) {
    var lesson = source[i]
    lessons.push({
      thumbnail: lesson.thumbnail,
      paths: [],
    })
    initScorePath(lessons[i].paths, lesson.paths)
  }
}
/**
 * 指定されたコンテンツデータ(Path一覧)からレッスンスコア用のPath一覧を作成する
 *
 * @param {Array} units レッスンスコア用のPath一覧
 * @param {Array} source コンテンツデータ(Path一覧)
 */
function initScorePath (paths, source) {
  for (var i = 0; i < source.length; i++) {
    var path = source[i]
    paths.push({
      title: path.title,
      answerRate: 0,
      ok: 0,
      ng: 0,
      skip: 0,
      count: 0,
      total: 0,
      status: constants.PATH_STATE_NOT_YET_STARTED,
      pathsteps: [],
    })
    var pathScore = paths[i]
    initScorePathsteps(pathScore.pathsteps, path.pathsteps)
    for (var pathstep of pathScore.pathsteps) {
      pathScore.total += pathstep.total
    }
  }
}
/**
 * 指定されたコンテンツデータ(Pathstep一覧)からレッスンスコア用のPathstep一覧を作成する
 *
 * @param {Array} units レッスンスコア用のPathstep一覧
 * @param {Array} source コンテンツデータ(Pathstep一覧)
 */
function initScorePathsteps (pathsteps, source) {
  // マイルストーンの場合
  if(source.length == 0) {
    for(var j = 0; j < mixinConstants.MILESTONE_QUESTION_COUNT; j++) {
      pathsteps.push({
        ok: 0,
        ng: 0,
        skip: 0,
        count: 0,
        total: 0,
        status: constants.PATHSTEP_STATE_NOT_YET_STARTED,
      })
    }
    return
  }

  for (var i = 0; i < source.length; i++) {
    var pathstep = source[i]
    pathsteps.push({
      ok: 0,
      ng: 0,
      skip: 0,
      count: 0,
      total: pathstep.acts.filter(function(act) { return act.challenge != 0 }).length,
      status: constants.PATHSTEP_STATE_NOT_YET_STARTED,
    })
  }
}
/**
 * レッスンスコアを計算する
 *
 * @param {Object} path スコア情報(Path)
 * @param {Object} pathstep スコア情報(Pathstep)
 */
function calcLessonScore(path, pathstep) {
  // 対象Pathstepの状態を設定
  if (pathstep.ok == pathstep.total) {
    pathstep.status = constants.PATHSTEP_STATE_COMPLETED
  } else if (0 < pathstep.ok) {
    pathstep.status = constants.PATHSTEP_STATE_IN_PROGRESS
  } else {
    pathstep.status = constants.PATHSTEP_STATE_NOT_YET_STARTED
  }

  // 対象Pathのスコア合計を計算
  path.ok = 0
  path.ng = 0
  path.skip = 0
  path.count = 0
  for (var pathstepsScore of path.pathsteps) {
    path.ok += pathstepsScore.ok
    path.ng += pathstepsScore.ng
    path.skip += pathstepsScore.skip
    path.count += pathstepsScore.count
  }

  // 対象Pathの状態を設定
  path.answerRate = Math.floor(path.ok / path.total * 100)
  if (path.count == 0) {
    path.status = constants.PATH_STATE_NOT_YET_STARTED
  } else if (path.skip == 0) {
    for (var pathstepsScore of path.pathsteps) {
      var val = pathstepsScore.ok + pathstepsScore.ng
      if(val == 0) {
        path.status = constants.PATH_STATE_IN_PROGRESS
        return
      }
    }
    path.status = constants.PATH_STATE_COMPLETED
  } else {
    path.status = constants.PATH_STATE_IN_PROGRESS
  }
}

/**
 * JSONのunitNoとnumberが一致するデータを取得
 */
function getUnitJson(levelJson, number) {
  var res = null

  for(var unit of levelJson.units) {
    if(unit.unitNo == number) {
      res = unit
      break
    }
  }
  return res
}



// WEBPACK FOOTER //
// ./src/store/lesson.js